(() => {
  const selector = '[data-pc-inline-quick-add]';
  const imageUrl = (variant) => {
    const src = variant.featured_image && variant.featured_image.src;
    return src && src.startsWith('//') ? `https:${src}` : (src || '');
  };

  let toastTimer;
  const showCartToast = (count) => {
    let toast = document.querySelector('[data-pc-cart-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'pc-cart-toast';
      toast.dataset.pcCartToast = '';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = Number.isFinite(count)
      ? `${count} ${count === 1 ? 'ITEM' : 'ITEMS'} IN YOUR BAG`
      : 'ADDED TO YOUR BAG';
    clearTimeout(toastTimer);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
  };

  const setup = (root) => {
    if (root.dataset.pcReady === 'true') return;
    root.dataset.pcReady = 'true';

    const options = JSON.parse(root.querySelector('[data-pc-product-options]').textContent);
    const variants = JSON.parse(root.querySelector('[data-pc-product-variants]').textContent);
    const optionsRoot = root.querySelector('[data-pc-options]');
    const addButton = root.querySelector('[data-pc-add]');
    const message = root.querySelector('[data-pc-message]');
    const tile = root.closest('data-island');
    const imageArea = tile && tile.querySelector('.group .relative.z-0');
    let image = imageArea && imageArea.querySelector('[data-pc-variant-image]');

    if (imageArea && !image) {
      image = document.createElement('img');
      image.className = 'pc-inline-quick-add__variant-image';
      image.dataset.pcVariantImage = '';
      image.alt = '';
      imageArea.appendChild(image);
    }

    const firstAvailable = variants.find((variant) => variant.available) || variants[0];
    const selected = firstAvailable ? [...firstAvailable.options] : [];
    const sizeIndex = options.findIndex((name) => /^size$/i.test(name));
    const isColor = (index) => /colou?r/i.test(options[index]);
    const defaultOnly = options.length === 1 && variants.length === 1 && variants[0].title === 'Default Title';
    const chosen = () => variants.find((variant) => variant.options.every((value, index) => selected[index] === value));
    const matchesOther = (variant, optionIndex) => selected.every((value, index) => index === optionIndex || variant.options[index] === value);
    const valueAvailable = (value, optionIndex) => variants.some((variant) => variant.available && variant.options[optionIndex] === value && (isColor(optionIndex) || matchesOther(variant, optionIndex)));
    const label = () => sizeIndex >= 0 && selected[sizeIndex] ? `ADD ${selected[sizeIndex].toUpperCase()} TO BAG +` : 'ADD TO BAG +';

    const updateImage = () => {
      if (!image) return;
      const variant = chosen();
      const src = variant && imageUrl(variant);
      if (src) {
        image.src = src;
        image.classList.add('is-visible');
      } else {
        image.removeAttribute('src');
        image.classList.remove('is-visible');
      }
    };

    const render = () => {
      optionsRoot.innerHTML = '';
      if (!defaultOnly) {
        options.forEach((name, optionIndex) => {
          const values = [...new Set(variants.map((variant) => variant.options[optionIndex]))];
          const group = document.createElement('fieldset');
          group.className = 'pc-inline-quick-add__group';
          const legend = document.createElement('legend');
          legend.className = 'pc-inline-quick-add__label';
          legend.textContent = name;
          group.appendChild(legend);
          const valuesRoot = document.createElement('div');
          valuesRoot.className = 'pc-inline-quick-add__values';

          values.forEach((value) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'pc-inline-quick-add__option';
            button.textContent = value;
            button.dataset.optionIndex = optionIndex;
            button.dataset.optionValue = value;
            button.setAttribute('aria-pressed', selected[optionIndex] === value ? 'true' : 'false');
            button.disabled = !valueAvailable(value, optionIndex);
            valuesRoot.appendChild(button);
          });

          group.appendChild(valuesRoot);
          optionsRoot.appendChild(group);
        });
      }

      const variant = chosen();
      addButton.disabled = !variant || !variant.available;
      addButton.textContent = variant && variant.available ? label() : 'SOLD OUT';
      updateImage();
    };

    optionsRoot.addEventListener('click', (event) => {
      const button = event.target.closest('[data-option-index]');
      if (!button || button.disabled) return;
      const optionIndex = Number(button.dataset.optionIndex);
      selected[optionIndex] = button.dataset.optionValue;
      const current = chosen();
      if (!current || !current.available) {
        const fallback = variants.find((variant) => variant.available && variant.options[optionIndex] === selected[optionIndex]);
        if (fallback) fallback.options.forEach((value, index) => { selected[index] = value; });
      }
      message.textContent = '';
      render();
    });

    addButton.addEventListener('click', async () => {
      const variant = chosen();
      if (!variant || !variant.available || addButton.disabled) return;
      addButton.disabled = true;
      addButton.textContent = 'ADDING…';
      message.textContent = '';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
        addButton.classList.add('is-added');
        addButton.textContent = 'ADDED TO BAG ✓';
        document.dispatchEvent(new CustomEvent('theme:update:cart'));
        let itemCount;
        try {
          const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
            headers: { Accept: 'application/json' }
          });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            itemCount = cart.item_count;
          }
        } catch (_) {
          // The item was added successfully; the count is only enhancement text.
        }
        showCartToast(itemCount);
        setTimeout(() => {
          addButton.classList.remove('is-added');
          addButton.disabled = false;
          addButton.textContent = label();
        }, 1200);
      } catch (error) {
        message.textContent = error.message;
        addButton.disabled = false;
        addButton.textContent = label();
      }
    });

    render();
  };

  const init = (scope = document) => scope.querySelectorAll(selector).forEach(setup);
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
